<div *ngIf="src" class="text-center">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">{{title ? title : ''}}</h5>
    <sb-button classes="close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </sb-button>
  </div>
  <img class="img-responsive" [src]="src"/>
</div>
